var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nsw-banner',{ref:"nsw"}),_vm._v(" "),_c('nsw-menu'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('nsw-module'),_vm._v(" "),_c('nsw-news')],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2d9208c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Home.vue
// module id = 7cwp
// module chunks = 2 3 4 5 6